<link rel="stylesheet" href="kartlegg-card.scss">
    <div class="card">

        <img class="image" src="assets/images/start-page.jpg" alt="Lykkelig eldre par hjemme">

        <div class="description">
        <h1>Boligkompasset</h1>
        <p>Få oversikt over hvordan boligen passer til behovene dine i dag, og hva du kan vurdere for fremtiden. Kartleggingen tar cirka 5-10 minutter.</p>
        <button hb-button class="button" (click)="navigateToKartlegging()">Prøv boligkompasset</button>
        </div>
</div>


